module.exports = __webpack_public_path__ + "media/images/new/cell_coverage_maps_phone-025132b39e72ae578e2b9ec5f0aa49ff.png";